import React,{Component} from 'react'
// import _ from 'lodash'
// import * as firebase from 'firebase'
// import SkeletonCard from './SkeletonCard'
import {
  PieChart,
  Pie,
  // Sector,
  Cell,
  Tooltip,
  Legend,
} from 'recharts'
import UnauthorizedText from './UnauthorizedText'
import {
  Accent,
  Primary,
  Purple,
  Green,
  LightGray,
} from '../helper/consts'

import '../styles/Dashboard.css'

const colors = [Primary,Accent,Purple,Green,LightGray,]

// const data = [
//   {name: 'Group A', value: 400},
//   {name: 'Group B', value: 300},
//   {name: 'Group C', value: 300},
//   {name: 'Group D', value: 200},
// ];

export default class AdminJobSummaryApplicationsPieChart extends Component{
  render(){
    let applications;
    applications = this.props.job.applications || {};
    let endorsements;
    endorsements = this.props.job.endorsements || {};
    const endorsed = Object.keys(endorsements)
    const applied = Object.keys(applications)
    // const endorsedAndApplied = endorsed.filter(uid=>{return applied.indexOf(uid)>=0})
    // const invited = this.props.job.invites;
    // const inviters = Object.keys(applications).map(uid=>applications[uid]).map(application=>application.oid)
    // const invitersCount = _.countBy(inviters);
    let formatted = [];
    // formatted = inviters.map((uid,i) => { return {['name']: i,['value']: invitersCount[uid],} })
    // endorsedAndApplied.length>0&&formatted.push({[`name`]: `Both`,[`value`]: endorsedAndApplied.length,})
    endorsed.length>0&&formatted.push({[`name`]: `Endorsed`,[`value`]: endorsed.length,})
    applied.length>0&&formatted.push({[`name`]: `Applied`,[`value`]: applied.length,})
    // invited>0&&formatted.push({[`name`]: `Invites`,[`value`]: invited,})
    return(
      formatted.length===0?
        <div className="noData">
          <UnauthorizedText subText='Not Enough Data' />
        </div>
      :
        <PieChart
          width={300}
          height={300}
        >
          <Pie
            data={formatted}
            dataKey="value"
            nameKey="name"
            innerRadius={50}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={1}
          >
            {formatted.map((entry, index) => <Cell key={index} fill={colors[index]}/>)}
          </Pie>
          <Tooltip/>
          <Legend />
        </PieChart>
    )
  }
}
// <PieChart width={300} height={300} onMouseEnter={this.onPieEnter}>
// <Pie
// data={formatted}
// dataKey="value"
// nameKey="name"
// innerRadius={50}
// outerRadius={80}
//
// paddingAngle={1}
// >
// {
//   formatted.map((entry, index) => <Cell key={index} fill={colors[index]}/>)
// }
// </Pie>
// <Tooltip/>
// <Legend />
// </PieChart>



// WEBPACK FOOTER //
// ./src/components/AdminJobSummaryApplicationsPieChart.js